'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.getDefaultValuesForModelType = getDefaultValuesForModelType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modelDefaultsOrganisationUnitGroupSet = require('./model-defaults/organisationUnitGroupSet');

var _modelDefaultsOrganisationUnitGroupSet2 = _interopRequireDefault(_modelDefaultsOrganisationUnitGroupSet);

var _modelDefaultsCategory = require('./model-defaults/category');

var _modelDefaultsCategory2 = _interopRequireDefault(_modelDefaultsCategory);

var _modelDefaultsCategoryOptionGroupSet = require('./model-defaults/categoryOptionGroupSet');

var _modelDefaultsCategoryOptionGroupSet2 = _interopRequireDefault(_modelDefaultsCategoryOptionGroupSet);

var _modelDefaultsDataElement = require('./model-defaults/dataElement');

var _modelDefaultsDataElement2 = _interopRequireDefault(_modelDefaultsDataElement);

var _modelDefaultsDataElementGroupSet = require('./model-defaults/dataElementGroupSet');

var _modelDefaultsDataElementGroupSet2 = _interopRequireDefault(_modelDefaultsDataElementGroupSet);

var _modelDefaultsDataSet = require('./model-defaults/dataSet');

var _modelDefaultsDataSet2 = _interopRequireDefault(_modelDefaultsDataSet);

var _modelDefaultsExternalMapLayer = require('./model-defaults/externalMapLayer');

var _modelDefaultsExternalMapLayer2 = _interopRequireDefault(_modelDefaultsExternalMapLayer);

var defaultValues = new Map([['organisationUnitGroupSet', _modelDefaultsOrganisationUnitGroupSet2['default']], ['category', _modelDefaultsCategory2['default']], ['categoryOptionGroupSet', _modelDefaultsCategoryOptionGroupSet2['default']], ['dataElement', _modelDefaultsDataElement2['default']], ['dataElementGroupSet', _modelDefaultsDataElementGroupSet2['default']], ['dataSet', _modelDefaultsDataSet2['default']], ['externalMapLayer', _modelDefaultsExternalMapLayer2['default']]]);

exports.defaultValues = defaultValues;

function getDefaultValuesForModelType(modelDefinitionName) {
    if (defaultValues.has(modelDefinitionName)) {
        return defaultValues.get(modelDefinitionName);
    }
    return {};
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/index.js
// module id = 85
// module chunks = 0